<div>


  <div class="nav-under container-fluid header-borders border-bottom py-2">
    <h5 class="bold" style="color: #212529;">Contacts</h5>
  </div>
  <div class="tabs border-bottom">
    <a class="tab-link active" (click)="openCity($event, 'inquiries')">Inquiries</a>
    <a class="tab-link" (click)="openCity($event, 'agronomists')">Agronomists</a>
    <a class="tab-link" (click)="openCity($event, 'diagnosisInquiry')">Diagnosis Inquiry</a>
  </div>
  <div class="container-fluid">
    <div id="inquiries" class="tabcontent">
      <app-inquiries
        [indiaStates]="indiaStates"
        [ugandaDistricts]="ugandaDistricts"
      >
      </app-inquiries>
    </div>
    <div id="agronomists" class="tabcontent" style="display: none;">
      <div class="mt-4">
        <div class=" row mb-2" *ngIf="!isLoadingContacts">
          <div class="col-md-8" [class.col-md-10]="contactsData?.length===0">
          </div>
          <div class="col">
            <button
              class="btn btn-primary btn-sm w-100"
              data-toggle="modal"
              data-target="#addContactModal"
            >
              Add Contact
            </button>
          </div>
          <div class="col" *ngIf="contactsData?.length>0">
            <button
                class="btn btn-danger btn-sm w-100"
                data-toggle="modal"
                data-target="#deleteContactModal"
              >
              Delete
            </button>
          </div>
          <div class="col-md-2" *ngIf="contactsData?.length>0 && countryName==='India'">
            <select
              name="filterStates"
              id="states2"
              style="width: 100%; cursor: pointer"
              class="px-2 py-1"
              (change)="onStateOptionSelected($event)"
            >
              <option *ngFor="let state of states">{{state}}</option>
            </select>
          </div>
          <div class="col-md-2" *ngIf="contactsData?.length>0 && countryName==='Uganda'">
            <select
              name="filterDistricts"
              id="states2"
              style="width: 100%; cursor: pointer"
              class="px-2 py-1"
              (change)="onDistrictOptionSelected($event)"
            >
              <option *ngFor="let district of districts">{{district}}</option>
            </select>
          </div>
        </div>
        <div class="spinner d-block w-100 py-5 text-center" *ngIf="isLoadingContacts">
          <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
        </div>
        <div *ngIf="!isLoadingContacts">
          <div *ngIf="contactsData?.length===0" style="text-align: center;">
            No contacts added yet...
          </div>
          <div *ngIf="contactsData?.length>0">
            <div>
              <div class="row mb-1">
                <div class="col-md-8">
                  <div class="h-100 d-flex align-items-center">
                    <h6 class="bold">Agronomists</h6>
                    <button
                      class="btn btn-primary btn-sm ml-3"
                      data-toggle="modal"
                      data-target="#addAgronomistModal"
                    >
                      Add Agronomist
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="agronomistsData?.length===0" style="text-align: center;">
                No agronomist contact added yet...
              </div>
              <div *ngIf="agronomistsData?.length>0">
                <table class="table table-bordered table-primary">
                  <thead>
                    <tr class="text-uppercase">
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Whatsapp</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of agronomistsData; let i = index">
                      <td>{{row.name}}</td>
                      <td>{{row.email}}</td>
                      <td>{{row.phone}}</td>
                      <td>{{row.whatsapp}}</td>
                      <td>
                        <div class="dropdown">
                          <button class="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            ACTION
                          </button>
                          <div class="dropdown-menu dropdown-menu-right options" aria-labelledby="dropdownMenuButton">
                            <button
                              class="dropdown-item suspend"
                              data-toggle="modal"
                              data-target="#editAgronomistModal"
                              (click)="setSingleAgronomistsViewData(row, i)"
                            >
                              View details
                            </button>
                            <button
                              class="dropdown-item suspend text-danger"
                              data-toggle="modal"
                              data-target="#deleteAgronomistModal"
                              (click)="setSingleAgronomistsViewData(row, i)"
                            >
                              Delete Contact
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="mt-5">
              <div class="row mb-1">
                <div class="col-md-8">
                  <div class="h-100 d-flex align-items-center">
                    <h6 class="bold">Sales Executives/ managers</h6>
                    <button
                      class="btn btn-primary btn-sm ml-3"
                      data-toggle="modal"
                      data-target="#addSalesMngrModal"
                      (click)="setSelectDistricts()"
                    >
                      Add Sales Manager
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="salesManagersData?.length===0" style="text-align: center; margin-top: 10px;">
                No sales manager contact added yet...
              </div>
              <div *ngIf="salesManagersData?.length>0">
                <table class="table table-bordered table-primary">
                  <thead>
                    <tr class="text-uppercase">
                      <th>#</th>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Whatsapp</th>
                      <th scope="col" *ngIf="countryName==='India'">District</th>
                      <th scope="col" *ngIf="countryName==='Uganda'">Sub county</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of salesManagersData | paginate: { id: 'paginate2', itemsPerPage: count, currentPage: agroPage };
                    let i = index">
                      <td>{{ (agroPage - 1) * count + i + 1 }}</td>
                      <td>{{row.name}}</td>
                      <td>{{row.email}}</td>
                      <td>{{row.phone}}</td>
                      <td>{{row.whatsapp}}</td>
                      <td *ngIf="countryName==='India'">{{row.district}}</td>
                      <td *ngIf="countryName==='Uganda'">{{row.sub_county}}</td>
                      <td>
                        <div class="dropdown">
                          <button class="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            ACTION
                          </button>
                          <div class="dropdown-menu dropdown-menu-right options" aria-labelledby="dropdownMenuButton">
                            <button
                              class="dropdown-item suspend"
                              data-toggle="modal"
                              data-target="#editSalesMngrModal"
                              (click)="setSingleSalesViewData(row, i)"
                            >
                              View details
                            </button>
                            <button
                              class="dropdown-item suspend text-danger"
                              data-toggle="modal"
                              data-target="#deleteSalesMngrModal"
                              (click)="setSingleSalesViewData(row, i)"
                            >
                              Delete Contact
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="salesManagersData?.length>0">
                <nav>
                  <pagination-controls id="paginate2" (pageChange)="agroPage = $event"></pagination-controls>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="diagnosisInquiry" class="tabcontent" style="display: none;">
      <app-diagnosis-inquiry></app-diagnosis-inquiry>
    </div>
  </div>

  <!-- Delete contact modal-->
  <div class="modal fade" id="deleteContactModal" tabindex="-1" role="dialog" aria-labelledby="deleteContactModal"
  aria-hidden="true">
   <div class="modal-dialog modal-dialog-centered" role="document">
     <div class="modal-content">
       <div class="modal-header no-border">
         <h5 class="modal-title text-primary">Delete Contact</h5>
         <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
           <span aria-hidden="true">&times;</span>
          </button>
       </div>
       <div class="modal-body">
         Are you sure you want to delete the contact for
         <span class="font-weight-bold" *ngIf="countryName==='India'">"{{ selectedState }}"</span>
         <span class="font-weight-bold" *ngIf="countryName==='Uganda'">"{{ selectedDistrict }}"</span>permanently?
       </div>
       <div class="modal-footer no-border">
         <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
         <button
           type="button"
           class="btn btn-primary"
           (click)="deleteContact(contactId)"
         >
           <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
           </span>
           <span *ngIf="loading" class="mx-2">Loading...</span>
           <span *ngIf="!loading">
              Delete Contact
           </span>
         </button>
       </div>
     </div>
   </div>
  </div>

  <!-- Add Contact Modal -->
  <div class="modal fade" id="addContactModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true" style="overflow: auto;">
    <div class="modal-dialog modal-md" role="document" (click)="onClickOutside()">
      <div class="modal-content container-fluid">
        <div class="modal-header no-border">
          <h5 class="modal-title text text-primary" style="font-weight: bold;">Add Contact</h5>
          <button
            type="button"
            class="close close-btn"
            aria-hidden="true"
            data-dismiss="modal"
            (click)="closeAddContactModal()"
            >&times;</button>
        </div>
        <div class="modal-body">
          <form
            class="form"
            [formGroup]="addContactForm"
            (ngSubmit)="addContacts()"
            id="addContactForm"
          >
            <div>
              <div class="form-group" *ngIf="countryName==='India'">
                <label for="state">State</label>
                <select
                  id="state"
                  formControlName="state"
                  style="width: 100%; cursor: pointer;"
                  class="form-control"
                  (change)="onStateOptionChosen($event)"
                >
                  <option hidden disabled selected value> -- select a state -- </option>
                  <option *ngFor="let state of contactStates">{{state}}</option>
                </select>
                  <div
                    *ngIf="(state.dirty || state.touched)"
                    class="text-danger error_message"
                  >
                    <span *ngIf="state.invalid && state.errors.required">
                      Please the state is required
                    </span>
                  </div>
              </div>
              <div class="form-group" *ngIf="countryName==='Uganda'">
                <label for="district">District</label>
                <select
                  id="district"
                  formControlName="district"
                  style="width: 100%; cursor: pointer;"
                  class="form-control"
                  (change)="onDistrictOptionChosen($event)"
                >
                  <option hidden disabled selected value> -- select a district -- </option>
                  <option *ngFor="let district of ugandaDistricts">{{district}}</option>
                </select>
                  <div
                    *ngIf="(addContactForm.get('district').dirty || addContactForm.get('district').touched)"
                    class="text-danger error_message"
                  >
                    <span *ngIf="addContactForm.get('district').invalid && addContactForm.get('district').errors.required">
                      Please the district is required
                    </span>
                  </div>
              </div>
              <div class="form-group">
                <label for="agronomist">Agronomist</label>
                <div class="contact-cards">
                  <div formArrayName="agronomist" *ngFor="let agronomist of addAgronomist().controls; let i = index">
                    <div class="form-group" [formGroupName]="i">
                      <div class="card p-4 mb-2">
                        <div class="card-block">
                          <div class="form-group">
                            <label for="name">Name</label>
                              <input
                                type="text"
                                class="form-control w-100"
                                id="agronomistName"
                                maxlength = "40"
                                formControlName="name"
                              >
                              <div
                                *ngIf="(agronomist.get('name').dirty || agronomist.get('name').touched)"
                                class="text-danger error_message"
                              >
                                <span *ngIf="agronomist.get('name').invalid && agronomist.get('name').errors.required">
                                  Please the name is required
                                </span>
                              </div>
                          </div>
                          <div class="form-group">
                            <label for="phone">Phone</label>
                              <input
                                type="tel"
                                class="form-control w-100"
                                id="agronomistPhone"
                                formControlName="phone"
                              >
                              <div
                                *ngIf="(agronomist.get('phone').dirty || agronomist.get('phone').touched)"
                                class="text-danger error_message"
                              >
                                <span *ngIf="agronomist.get('phone').invalid && agronomist.get('phone').errors.required">
                                  Please the phone is required
                                </span>
                                <span *ngIf="agronomist.get('phone').invalid && agronomist.get('phone').errors.pattern">
                                  Please enter a valid phone number,
                                  not beyond 15 digits and without spaces,
                                  in the format XXX... or +XXX...
                                </span>
                              </div>
                          </div>
                          <div class="form-group">
                            <label for="whatsapp">Whatsapp</label>
                              <input
                                type="tel"
                                class="form-control w-100"
                                id="agronomistWhatsapp"
                                formControlName="whatsapp"
                              >
                              <div
                                *ngIf="(agronomist.get('whatsapp').dirty || agronomist.get('whatsapp').touched)"
                                class="text-danger error_message"
                              >
                                <span *ngIf="agronomist.get('whatsapp').invalid && agronomist.get('whatsapp').errors.pattern">
                                  Please enter a valid phone number,
                                  not beyond 15 digits and without spaces,
                                  in the format XXX... or +XXX...
                                </span>
                              </div>
                          </div>
                          <div class="form-group">
                            <label for="email">Email</label>
                              <input
                                type="email"
                                class="form-control w-100"
                                id="agronomistEmail"
                                formControlName="email"
                              >
                              <div
                                *ngIf="(agronomist.get('email').dirty || agronomist.get('email').touched)"
                                class="text-danger error_message"
                              >
                                <span *ngIf="agronomist.get('email').invalid && agronomist.get('email').errors.required">
                                  Please the email is required
                                </span>
                                <span *ngIf="agronomist.get('email').invalid && agronomist.get('email').errors.email">
                                  Please enter a valid email address,
                                  in the format a@b.c or a.b@c.d or a-b@c.d or a_b@c.d or a.b@c-d.com
                                </span>
                              </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                (click)="removeAgronomist(i)"
                              >Remove</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div (click)="addNewAgronomist()" class="col">
                    <div class="card bg-light" id="add-card">
                      <div class="card-body text-center">
                        <i class="fas fa-plus"></i>
                        <p class="card-text">Add</p>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="salesMngr">Sales manager/ Executive</label>
                <div class="contact-cards">
                  <div formArrayName="customer_service" *ngFor="let salesmngr of addSalesMngr().controls; let i = index">
                    <div class="form-group" [formGroupName]="i">
                      <div class="card p-4 mt-1">
                        <div class="card-block">
                          <div class="form-group">
                            <label for="name">Name</label>
                              <input
                                type="text"
                                class="form-control w-100"
                                maxlength = "40"
                                formControlName="name"
                              >
                              <div
                                *ngIf="(salesmngr.get('name').dirty || salesmngr.get('name').touched)"
                                class="text-danger error_message"
                              >
                                <span *ngIf="salesmngr.get('name').invalid && salesmngr.get('name').errors.required">
                                  Please the name is required
                                </span>
                              </div>
                          </div>
                          <div class="form-group">
                            <label for="phone">Phone</label>
                              <input
                                type="tel"
                                class="form-control w-100"
                                formControlName="phone"
                              >
                              <div
                                *ngIf="(salesmngr.get('phone').dirty || salesmngr.get('phone').touched)"
                                class="text-danger error_message"
                              >
                                <span *ngIf="salesmngr.get('phone').invalid && salesmngr.get('phone').errors.required">
                                  Please the phone is required
                                </span>
                                <span *ngIf="salesmngr.get('phone').invalid && salesmngr.get('phone').errors.pattern">
                                  Please enter a valid phone number,
                                  not beyond 15 digits and without spaces,
                                  in the format XXX... or +XXX...
                                </span>
                              </div>
                          </div>
                          <div class="form-group">
                            <label for="whatsapp">Whatsapp</label>
                              <input
                                type="tel"
                                class="form-control w-100"
                                formControlName="whatsapp"
                              >
                              <div
                                *ngIf="(salesmngr.get('whatsapp').dirty || salesmngr.get('whatsapp').touched)"
                                class="text-danger error_message"
                              >
                                <span *ngIf="salesmngr.get('whatsapp').invalid && salesmngr.get('whatsapp').errors.pattern">
                                  Please enter a valid phone number,
                                  not beyond 15 digits and without spaces,
                                  in the format XXX... or +XXX...
                                </span>
                              </div>
                          </div>
                          <div class="form-group">
                            <label for="email">Email</label>
                              <input
                                type="email"
                                class="form-control w-100"
                                formControlName="email"
                              >
                              <div
                                *ngIf="(salesmngr.get('email').dirty || salesmngr.get('email').touched)"
                                class="text-danger error_message"
                              >
                                <span *ngIf="salesmngr.get('email').invalid && salesmngr.get('email').errors.required">
                                  Please the email is required
                                </span>
                                <span *ngIf="salesmngr.get('email').invalid && salesmngr.get('email').errors.email">
                                  Please enter a valid email address,
                                  in the format a@b.c or a.b@c.d or a-b@c.d or a_b@c.d or a.b@c-d.com
                                </span>
                              </div>
                          </div>
                          <div class="form-group" *ngIf="countryName==='India'">
                            <label for="district">District</label>
                              <p-multiSelect
                                autoWidth="false"
                                [style]="{'width':'100%', 'height': '35px'}"
                                [options] = "districtsToSelect"
                                id="selectItem"
                                formControlName="district"
                              >
                              </p-multiSelect>
                          </div>
                          <div class="form-group" *ngIf="countryName==='Uganda'">
                            <label for="subcounty">Sub County</label>
                              <p-multiSelect
                                autoWidth="false"
                                [style]="{'width':'100%', 'height': '35px'}"
                                [options] = "subcountiesToSelect"
                                formControlName="sub_county"
                              >
                              </p-multiSelect>
                          </div>
                          <div class="row">
                            <div class="col">
                              <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                (click)="removeSalesMngr(i)"
                              >Remove</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div (click)="addNewSalesMngr()" class="col">
                    <div class="card bg-light" id="add-card">
                      <div class="card-body text-center">
                        <i class="fas fa-plus"></i>
                        <p class="card-text">Add</p>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div class="modal-footer no-border">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeAddContactModal()">Cancel</button>
              <button
                type="submit"
                class="btn btn-primary float-right"
                [disabled]="!addContactForm.valid"
              >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Add Contact
              </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Add agronomist Modal -->
  <div class="modal fade" id="addAgronomistModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true" style="overflow: auto;">
    <div class="modal-dialog modal-md" role="document" (click)="onClickOutside()">
      <div class="modal-content container-fluid">
        <div class="modal-header no-border">
          <h5 class="modal-title text text-primary" style="font-weight: bold;">Add Agronomist</h5>
          <button
            type="button"
            class="close close-btn"
            aria-hidden="true"
            data-dismiss="modal"
            (click)="closeAddAgroContactModal()"
            >&times;</button>
        </div>
        <div class="modal-body">
          <form
            class="form"
            #addAgronomistsForm="ngForm"
            (ngSubmit)="addAgronomists(addAgronomistsForm.value)"
            id="addAgronomistForm"
          >
            <div>
              <div class="form-group">
                <label for="name">Name</label>
                  <input
                    type="text"
                    class="form-control"
                    maxlength = "40"
                    name="agro_name"
                    #agro_name="ngModel"
                    [(ngModel)]="model.agro_name"
                    required
                  >
                  <div
                  *ngIf="agro_name.touched && !agro_name.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="agro_name.hasError('required')">
                      Please the name is required
                    </span>
                  </div>
              </div>
              <div class="form-group">
                <label for="phone">Phone</label>
                  <input
                    type="tel"
                    class="form-control"
                    name="agro_phone"
                    #agro_phone="ngModel"
                    [(ngModel)]="model.agro_phone"
                    pattern="^\+?\d{1,15}$"
                    required
                  >
                  <div
                  *ngIf="agro_phone.touched && !agro_phone.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="agro_phone.hasError('required')">
                      Please the phone number is required
                    </span>
                    <span *ngIf="agro_phone.hasError('pattern')">
                      Please enter a valid phone number,
                      not beyond 15 digits and without spaces,
                      in the format XXX... or +XXX...
                    </span>
                  </div>
              </div>
              <div class="form-group">
                <label for="whatsapp">Whatsapp</label>
                  <input
                    type="tel"
                    class="form-control"
                    name="agro_whatsapp"
                    #agro_whatsapp="ngModel"
                    [(ngModel)]="model.agro_whatsapp"
                    pattern="^\+?\d{1,15}$"
                  >
                  <div
                  *ngIf="agro_whatsapp.touched && !agro_whatsapp.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="agro_whatsapp.hasError('pattern')">
                      Please enter a valid phone number,
                      not beyond 15 digits and without spaces,
                      in the format XXX... or +XXX...
                    </span>
                  </div>
              </div>
              <div class="form-group">
                <label for="email">Email</label>
                  <input
                    type="email"
                    class="form-control"
                    name="agro_email"
                    #agro_email="ngModel"
                    [(ngModel)]="model.agro_email"
                    pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                    required
                  >
                  <div
                  *ngIf="agro_email.touched && !agro_email.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="agro_email.hasError('required')">
                      Please the email is required
                    </span>
                    <span *ngIf="agro_email.hasError('pattern')">
                      Please enter a valid email address,
                      in the format a@b.c or a.b@c.d or a-b@c.d or a_b@c.d or a.b@c-d.com
                    </span>
                  </div>
              </div>
            </div>
            <br>
            <div class="modal-footer no-border">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                (click)="closeAddAgroContactModal()">Cancel</button>
              <button
                type="submit"
                class="btn btn-primary float-right"
                [disabled]="!addAgronomistsForm.form.valid"
              >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Save Changes
              </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Edit agronomist Modal -->
  <div class="modal fade" id="editAgronomistModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true" style="overflow: auto;">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content container-fluid">
        <div class="modal-header no-border">
          <h5 class="modal-title text text-primary" style="font-weight: bold;">Edit Agronomist</h5>
          <button
            type="button"
            class="close close-btn"
            aria-hidden="true"
            data-dismiss="modal"
            >&times;</button>
        </div>
        <div class="modal-body">
          <form
            *ngIf="singleAgronomistsViewData"
            class="form"
            #editAgronomistsForm="ngForm"
            (ngSubmit)="editAgronomists(editAgronomistsForm.value)"
            id="editAgronomistForm"
          >
            <div>
              <div class="form-group">
                <label for="name">Name</label>
                  <input
                    type="text"
                    class="form-control"
                    maxlength = "40"
                    name="agro_name"
                    #agro_name="ngModel"
                    [(ngModel)]="singleAgronomistsViewData.name"
                    required
                  >
                  <div
                  *ngIf="agro_name.touched && !agro_name.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="agro_name.hasError('required')">
                      Please the name is required
                    </span>
                  </div>
              </div>
              <div class="form-group">
                <label for="phone">Phone</label>
                  <input
                    type="tel"
                    class="form-control"
                    name="agro_phone"
                    #agro_phone="ngModel"
                    [(ngModel)]="singleAgronomistsViewData.phone"
                    pattern="^\+?\d{1,15}$"
                    required
                  >
                  <div
                  *ngIf="agro_phone.touched && !agro_phone.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="agro_phone.hasError('required')">
                      Please the phone number is required
                    </span>
                    <span *ngIf="agro_phone.hasError('pattern')">
                      Please enter a valid phone number,
                      not beyond 15 digits and without spaces,
                      in the format XXX... or +XXX...
                    </span>
                  </div>
              </div>
              <div class="form-group">
                <label for="whatsapp">Whatsapp</label>
                  <input
                    type="tel"
                    class="form-control"
                    name="agro_whatsapp"
                    #agro_whatsapp="ngModel"
                    [(ngModel)]="singleAgronomistsViewData.whatsapp"
                    pattern="^\+?\d{1,15}$"
                  >
                  <div
                  *ngIf="agro_whatsapp.touched && !agro_whatsapp.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="agro_whatsapp.hasError('pattern')">
                      Please enter a valid phone number,
                      not beyond 15 digits and without spaces,
                      in the format XXX... or +XXX...
                    </span>
                  </div>
              </div>
              <div class="form-group">
                <label for="email">Email</label>
                  <input
                    type="email"
                    class="form-control"
                    name="agro_email"
                    #agro_email="ngModel"
                    [(ngModel)]="singleAgronomistsViewData.email"
                    pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                    required
                  >
                  <div
                  *ngIf="agro_email.touched && !agro_email.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="agro_email.hasError('required')">
                      Please the email is required
                    </span>
                    <span *ngIf="agro_email.hasError('pattern')">
                      Please enter a valid email address,
                      in the format a@b.c or a.b@c.d or a-b@c.d or a_b@c.d or a.b@c-d.com
                    </span>
                  </div>
              </div>
            </div>
            <br>
            <div class="modal-footer no-border">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button
                type="submit"
                class="btn btn-primary float-right"
                [disabled]="!editAgronomistsForm.form.valid"
              >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Save Changes
              </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete agronomist modal-->
  <div class="modal fade" id="deleteAgronomistModal" tabindex="-1" role="dialog" aria-labelledby="deleteAgronomistModal"
  aria-hidden="true">
   <div class="modal-dialog modal-dialog-centered" role="document">
     <div class="modal-content">
       <div class="modal-header no-border">
         <h5 class="modal-title text-primary">Delete Agronomist</h5>
         <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
           <span aria-hidden="true">&times;</span>
          </button>
       </div>
       <div class="modal-body">
         This agronomist contact will be deleted permanently.
         Do you wish to continue?
       </div>
       <div class="modal-footer no-border">
         <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
         <button
           type="button"
           class="btn btn-primary"
           (click)="deleteAgronomistContact(agroIndex)"
         >
           <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
           </span>
           <span *ngIf="loading" class="mx-2">Loading...</span>
           <span *ngIf="!loading">
              Yes, Delete
           </span>
         </button>
       </div>
     </div>
   </div>
  </div>

  <!-- Add sales manager Modal -->
  <div class="modal fade" id="addSalesMngrModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true" style="overflow: auto;">
    <div class="modal-dialog modal-md" role="document" (click)="onClickOutside()">
      <div class="modal-content container-fluid">
        <div class="modal-header no-border">
          <h5 class="modal-title text text-primary" style="font-weight: bold;">Add Sales Manager/ Executive</h5>
          <button
            type="button"
            class="close close-btn"
            aria-hidden="true"
            data-dismiss="modal"
            (click)="closeAddSalesContactModal()"
            >&times;</button>
        </div>
        <div class="modal-body">
          <form
            class="form"
            #addSalesManagerForm="ngForm"
            (ngSubmit)="addSalesManager(addSalesManagerForm.value)"
            id="addSalesMngrForm"
          >
            <div>
              <div class="form-group">
                <label for="name">Name</label>
                  <input
                    type="text"
                    class="form-control"
                    maxlength = "40"
                    name="sales_name"
                    #sales_name="ngModel"
                    [(ngModel)]="model.sales_name"
                    required
                  >
                  <div
                  *ngIf="sales_name.touched && !sales_name.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="sales_name.hasError('required')">
                      Please the name is required
                    </span>
                  </div>
              </div>
              <div class="form-group">
                <label for="phone">Phone</label>
                  <input
                    type="tel"
                    class="form-control"
                    name="sales_phone"
                    #sales_phone="ngModel"
                    [(ngModel)]="model.sales_phone"
                    pattern="^\+?\d{1,15}$"
                    required
                  >
                  <div
                  *ngIf="sales_phone.touched && !sales_phone.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="sales_phone.hasError('required')">
                      Please the phone number is required
                    </span>
                    <span *ngIf="sales_phone.hasError('pattern')">
                      Please enter a valid phone number,
                      not beyond 15 digits and without spaces,
                      in the format XXX... or +XXX...
                    </span>
                  </div>
              </div>
              <div class="form-group">
                <label for="whatsapp">Whatsapp</label>
                  <input
                    type="tel"
                    class="form-control"
                    name="sales_whatsapp"
                    #sales_whatsapp="ngModel"
                    [(ngModel)]="model.sales_whatsapp"
                    pattern="^\+?\d{1,15}$"
                  >
                  <div
                  *ngIf="sales_whatsapp.touched && !sales_whatsapp.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="sales_whatsapp.hasError('pattern')">
                      Please enter a valid phone number,
                      not beyond 15 digits and without spaces,
                      in the format XXX... or +XXX...
                    </span>
                  </div>
              </div>
              <div class="form-group">
                <label for="email">Email</label>
                  <input
                    type="email"
                    class="form-control"
                    name="sales_email"
                    #sales_email="ngModel"
                    [(ngModel)]="model.sales_email"
                    pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                    required
                  >
                  <div
                  *ngIf="sales_email.touched && !sales_email.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="sales_email.hasError('required')">
                      Please the email is required
                    </span>
                    <span *ngIf="sales_email.hasError('pattern')">
                      Please enter a valid email address,
                      in the format  a@b.c or a.b@c.d or a-b@c.d or a_b@c.d or a.b@c-d.com
                    </span>
                  </div>
              </div>
              <div class="form-group" *ngIf="countryName==='India'">
                <label for="district">District</label>
                  <p-multiSelect
                    autoWidth="false"
                    [style]="{'width':'100%', 'height': '35px'}"
                    [options] = "districtsToSelect"
                    optionLabel="label"
                    id="selectItem"
                    #selectItems="ngModel"
                    name="selectedItems"
                    [(ngModel)]="selectedItems"
                  >
                  </p-multiSelect>
              </div>
              <div class="form-group" *ngIf="countryName==='Uganda'">
                <label for="subcounty">Sub county</label>
                  <p-multiSelect
                    autoWidth="false"
                    [style]="{'width':'100%', 'height': '35px'}"
                    [options] = "subcountiesToSelect"
                    optionLabel="label"
                    id="selectSubcounty"
                    #selectItems="ngModel"
                    name="selectedItems"
                    [(ngModel)]="selectedItems"
                  >
                  </p-multiSelect>
              </div>
            </div>
            <br>
            <div class="modal-footer no-border">
              <button
                type="button"
                class="btn btn-secondary"
                (click)="closeAddSalesContactModal()"
                data-dismiss="modal">Cancel</button>
              <button
                type="submit"
                class="btn btn-primary float-right"
                [disabled]="!addSalesManagerForm.form.valid"
              >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Save Changes
              </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Edit sales manager Modal -->
  <div class="modal fade" id="editSalesMngrModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true" style="overflow: auto;">
    <div class="modal-dialog modal-md" role="document" (click)="onClickOutside()">
      <div class="modal-content container-fluid">
        <div class="modal-header no-border">
          <h5 class="modal-title text text-primary" style="font-weight: bold;">Edit Sales Manager/ Executive</h5>
          <button
            type="button"
            class="close close-btn"
            aria-hidden="true"
            data-dismiss="modal"
            (click)="closeEditSalesContactModal()"
            >&times;</button>
        </div>
        <div class="modal-body">
          <form
            *ngIf="singleSalesMngrData"
            class="form"
            #editSalesManagerForm="ngForm"
            (ngSubmit)="editSalesManager(editSalesManagerForm.value)"
            id="editSalesMngrForm"
          >
            <div>
              <div class="form-group">
                <label for="name">Name</label>
                  <input
                    type="text"
                    class="form-control"
                    maxlength = "40"
                    name="sales_name"
                    #sales_name="ngModel"
                    [(ngModel)]="singleSalesMngrData.name"
                    required
                  >
                  <div
                  *ngIf="sales_name.touched && !sales_name.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="sales_name.hasError('required')">
                      Please the name is required
                    </span>
                  </div>
              </div>
              <div class="form-group">
                <label for="phone">Phone</label>
                  <input
                    type="tel"
                    class="form-control"
                    name="sales_phone"
                    #sales_phone="ngModel"
                    [(ngModel)]="singleSalesMngrData.phone"
                    pattern="^\+?\d{1,15}$"
                    required
                  >
                  <div
                  *ngIf="sales_phone.touched && !sales_phone.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="sales_phone.hasError('required')">
                      Please the phone number is required
                    </span>
                    <span *ngIf="sales_phone.hasError('pattern')">
                      Please enter a valid phone number,
                      not beyond 15 digits and without spaces,
                      in the format XXX... or +XXX...
                    </span>
                  </div>
              </div>
              <div class="form-group">
                <label for="whatsapp">Whatsapp</label>
                  <input
                    type="tel"
                    class="form-control"
                    name="sales_whatsapp"
                    #sales_whatsapp="ngModel"
                    [(ngModel)]="singleSalesMngrData.whatsapp"
                    pattern="^\+?\d{1,15}$"
                  >
                  <div
                  *ngIf="sales_whatsapp.touched && !sales_whatsapp.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="sales_whatsapp.hasError('pattern')">
                      Please enter a valid phone number,
                      not beyond 15 digits and without spaces,
                      in the format XXX... or +XXX...
                    </span>
                  </div>
              </div>
              <div class="form-group">
                <label for="email">Email</label>
                  <input
                    type="email"
                    class="form-control"
                    name="sales_email"
                    #sales_email="ngModel"
                    [(ngModel)]="singleSalesMngrData.email"
                    pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                    required
                  >
                  <div
                  *ngIf="sales_email.touched && !sales_email.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="sales_email.hasError('required')">
                      Please the email is required
                    </span>
                    <span *ngIf="sales_email.hasError('pattern')">
                      Please enter a valid email address,
                      in the format  a@b.c or a.b@c.d or a-b@c.d or a_b@c.d or a.b@c-d.com
                    </span>
                  </div>
              </div>
              <div class="form-group" *ngIf="countryName==='India'">
                <label for="district">District</label>
                  <p-multiSelect
                    autoWidth="false"
                    [style]="{'width':'100%', 'height': '35px'}"
                    [options] = "districtsToSelect"
                    optionLabel="label"
                    id="selectItem"
                    #selectItems="ngModel"
                    name="selectedItems"
                    [(ngModel)]="selectedItems"
                  >
                  </p-multiSelect>
              </div>
              <div class="form-group" *ngIf="countryName==='Uganda'">
                <label for="district">Sub county</label>
                  <p-multiSelect
                    autoWidth="false"
                    [style]="{'width':'100%', 'height': '35px'}"
                    [options] = "subcountiesToSelect"
                    optionLabel="label"
                    #selectItems="ngModel"
                    name="selectedItems"
                    [(ngModel)]="selectedItems"
                  >
                  </p-multiSelect>
              </div>
            </div>
            <br>
            <div class="modal-footer no-border">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                (click)="closeEditSalesContactModal()"
                >Cancel</button>
              <button
                type="submit"
                class="btn btn-primary float-right"
                [disabled]="!editSalesManagerForm.form.valid"
              >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Save Changes
              </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete sales manager modal-->
  <div class="modal fade" id="deleteSalesMngrModal" tabindex="-1" role="dialog" aria-labelledby="deleteSalesMngrModal"
  aria-hidden="true">
   <div class="modal-dialog modal-dialog-centered" role="document">
     <div class="modal-content">
       <div class="modal-header no-border">
         <h5 class="modal-title text-primary">Delete Sales Manager</h5>
         <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
           <span aria-hidden="true">&times;</span>
          </button>
       </div>
       <div class="modal-body">
         This sales manager contact will be deleted permanently.
         Do you wish to continue?
       </div>
       <div class="modal-footer no-border">
         <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
         <button
           type="button"
           class="btn btn-primary"
           (click)="deleteSalesMngrContact(salesIndex)"
         >
           <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
           </span>
           <span *ngIf="loading" class="mx-2">Loading...</span>
           <span *ngIf="!loading">
              Yes, Delete
           </span>
         </button>
       </div>
     </div>
   </div>
  </div>
</div>
